module.exports = __webpack_public_path__ + "static/media/Caristo_Flyer_1413.5e7150d2.pdf";